export class UserImage {
    userId: number
    base64Image: string

    constructor(userId: number, base64image: string) {
        this.userId = userId
        this.base64Image = base64image
    }
}
